export function detectIE() {
  let ua = window.navigator.userAgent

  let msie = ua.indexOf('MSIE') > -1
  let trident = ua.indexOf('Trident/') > -1
  let edge = ua.indexOf('Edge/') > -1

  return (msie || trident || edge)
}